module.exports = __webpack_public_path__ + "static/media/rose.7325e81c.png";